import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SubmissionTag, SubmissionSubtagMapping } from "../../sdk/models/";
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class SubmissionDetailService {

  private tagMappingSrc = new Subject<boolean>();
  private subTagMappingSrc = new Subject<boolean>();
  private submissionId;
  private tagMappings: Array<Array<SubmissionTag>>;
  private subTagMappings: Array<Array<SubmissionSubtagMapping>>;

  constructor(
    private router: Router
  ) {
  }

  tagMapping$ = this.tagMappingSrc.asObservable();

  tagMappingChanged(show: boolean) {
    this.tagMappingSrc.next(show);
  }

  setTagMapping(id, tm: Array<SubmissionTag>){
    // console.log("setTagMapping");
    if (this.tagMappings == null) {
      this.tagMappings = new Array();
      // this.tagMappings.push(tm);
      
    }
      this.tagMappings[id] = tm;
    

    // console.log(this.tagMappings)
  }

  getTagMapping(id){
    return this.tagMappings[id];
  }

  subTagMapping$ = this.subTagMappingSrc.asObservable();

  subTagMappingChanged(show: boolean) {
    this.subTagMappingSrc.next(show);
  }

  setSubTagMapping(id, tm: Array<SubmissionSubtagMapping>){
    // console.log("setSubTagMapping");
    if (this.subTagMappings == null) {
      this.subTagMappings = new Array();
      // this.subTagMappings.push(tm);
      
    }
      this.subTagMappings[id] = tm;

    // console.log(this.subTagMappings)
  }

  getSubTagMapping(id){
    return this.subTagMappings[id];
  }

  setCurrentSubmissionId(id){
    this.submissionId = id;
  }

  getCurrentSubmissionId(){
    return this.submissionId;
  }

  tagExists(id, status: number) : boolean {
    return !!this.tagMappings[id].find(
      elem => {
        return elem.tag_id == status}
    );
  }

  currentTag(id, status: number) : boolean {
    return !!this.tagMappings[id].find(
      elem => {
        return (elem.tag_id == status && elem.current == true) }
    );
  }

  subtagExists(id, status: number) : boolean {
    // console.log("this.subTagMappings[id]");
    // console.log(this.subTagMappings[id]);
    // console.log(id);
    return !!this.subTagMappings[id].find(
      elem => {
        return elem.subtag_id == status}
    );
  }
}
